import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import './style.css'

export default function Sidebar() {
    return (
        <aside className="app-sidebar">
            {/* <div className="sidebar-title">Menu</div> */}
            <div className="sidebar-item">
                <Link
                className='sidebar-item'
                    to='/dashboard'
                >Dashboard</Link>
            </div>
            <div className="sidebar-item">
                <Link
                className='sidebar-item'
                    to='/report'
                >Report</Link>
            </div>
            {/* <div className="sidebar-item">Users</div>
        <div className="sidebar-item">Orders</div>
        <div className="sidebar-item">Settings</div> */}
        </aside>
    )
}